export const PACK_QUESTION_DESCRIPTION = {
  ai: "AI answers first, using your PayPack. Authorized managers can read the conversation. You can request a manager after you send your question.",
  manager:
    "Tell your manager what doesn't look right. They'll see the same PayPack you're looking at now.",
} as const;
